import { render, staticRenderFns } from "./ApprovalDetails.vue?vue&type=template&id=0fe896ff&scoped=true&"
import script from "./ApprovalDetails.vue?vue&type=script&lang=js&"
export * from "./ApprovalDetails.vue?vue&type=script&lang=js&"
import style0 from "./ApprovalDetails.vue?vue&type=style&index=0&id=0fe896ff&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe896ff",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCardText,VCardTitle,VCol,VRow})
